// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 504) return "static/chunks/504.b98d3e2cfb1259bc.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"653":"b33344ff0a3427f3","999":"ac855a21328c7d2e"}[chunkId] + ".js";
};